import { Typography } from '@volvo/vcdk-react';
import React from 'react';

import StylizedUnitsIllustration from '@/assets/multiple_stylized_units_v2.svg';

type Props = {
  title: string;
  message?: string;
  actions?: React.ReactNode;
};

const EmptyState: React.FC<Props> = ({ title, message, actions }) => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center">
      <div className="mx-auto flex max-w-[364px] flex-col text-center">
        <img src={StylizedUnitsIllustration} alt="boats and industrial machines" className="mb-6 w-full" />
        <Typography variant="heading3" className="mb-4">
          {title}
        </Typography>
        {message && <Typography variant="body">{message}</Typography>}
        {actions && <div className="mt-8 flex w-full justify-center gap-4">{actions}</div>}
      </div>
    </div>
  );
};

export default EmptyState;
